<template>
  <el-dialog
    custom-class="global-rp-notice"
    v-if="couponList.length"
    :visible.sync="showFirstOrderReward"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <div class="wrap-c">
      <div class="title">{{$t('components_dialogredbag_first_order_reward_1779')}}</div>
      <div class="line"></div>
      <img class="ribbon" :src="require('@/assets/image/background/ribbon.png')" />
      <div class="item" v-for="(item,index) in couponList" :key="index">
        <div class="left">
          <b>{{$t('upgrade_page_views_order_components_pay_info_343', [item.couponAmount])}}</b>
          <div>{{item.satisfyConditionDesc}}</div>
        </div>
        <div class="right">
          <b>{{item.couponName.includes($t('upgrade_page_views_order_components_coupons_bar_339'))?$t('components_dialogredbag_first_order_reward_1780'):item.couponName}}</b>
          <div>{{$t('components_dialogredbag_first_order_reward_1783',[new Date(item.deadlineTimestamp).$format('yyyy.MM.dd')])}}</div>
        </div>
      </div>
      <button class="btn-get" @click="onClose">{{$t('components_dialogredbag_first_order_reward_1782')}}</button>
    </div>
    <button class="close-btn pointer" @click="onClose"></button>
  </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['accountInfo']),
    couponList() {
      if (!this.accountInfo) return []
      return (this.accountInfo.couponInfoList || []).filter(
        (item) => {
          return ['IMMEDIATE_DISCOUNT', 'EXCLUSIVE_COUPON'].includes(item.couponTemplate) && item.couponStatus === 'EFFECT';
        }
      ).slice(0, 2)
    },
  },
  data() {
    return {
      showFirstOrderReward: !localStorage.getItem('showedFirstOrderReward'),
    }
  },
  methods: {
    onClose() {
      this.showFirstOrderReward = false;
      localStorage.setItem('showedFirstOrderReward', 1);
    },
  }
}
</script>
<style lang="scss">
.global-rp-notice {
  width: 289px;
  height: 360px;
  background: #df3a34;
  border-radius: 20px;
  .wrap-c {
    @include flex(center, center, column);
  }
  .title {
    color: #ffdd1e;
    font-size: 22px;
    margin-bottom: 32px;
  }
  .line {
    height: 16px;
    width: 275px;
    left: 50px;
    top: 290px;
    border-radius: 16px;
    background: #a11711;
    position: absolute;
    top: 80px;
    left: 7px;
  }
  .ribbon {
    position: absolute;
    height: 232px;
    width: 373px;
    left: -40px;
    top: -40px;
    z-index: 1;
  }
  .item {
    position: relative;
    width: 263px;
    height: 72px;
    background: #fff;
    border-radius: 6px;
    margin-bottom: 8px;
    @include flex();
    .left {
      height: 72px;
      width: 97px;
      left: 56px;
      top: 298px;
      background: #fcf6e4;
      color: #ed7433;
      font-size: 14px;
      @include flex(center, center, column);
      b {
        font-size: 20px;
      }
    }
    .right {
      flex: 1;
      padding: 18px 12px;
      color: #999;
      font-size: 12px;
      height: 100%;
      @include flex(space-around, flex-start, column);
      b {
        font-size: 14px;
        color: #000;
      }
    }
  }
  .el-dialog__header {
    padding: 0;
  }
  .btn-get {
    background: linear-gradient(180deg, #ffdd1e 0%, #ffa51e 100%);
    height: 52px;
    width: 174px;
    left: 101px;
    top: 486px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 36px;
  }
}
.close-btn {
  position: absolute;
  bottom: -66px;
  left: 50%;
  transform: translateX(-18px);
  display: block;
  width: 37px;
  height: 37px;
  margin: 100px auto 0;
  background: url('~@/assets/image/icons/close-icon-border.png') no-repeat
    center center;
  background-size: contain;
}
</style>